import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import React from 'react';

interface Props {
  text: string;
}

export const DividerWithText: React.FC<Props> = ({text}: Props): React.ReactElement => {
  const {backgroundColor, hasDarkBg} = useThemeContext();

  return (
    <div className="relative">
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div
          className={classNames(
            'w-full border-t',
            hasDarkBg ? 'border-white/30' : 'border-black/30'
          )}
        />
      </div>
      <div className="relative flex justify-center">
        <span
          className={classNames(
            'bg-white px-2 text-sm',
            hasDarkBg ? 'text-white/50' : 'text-black/50'
          )}
          style={{backgroundColor}}
        >
          {text}
        </span>
      </div>
    </div>
  );
};
DividerWithText.displayName = 'DividerWithText';
